import React from 'react'
import {Button} from 'antd'

const RecipeDetail = ({recipeId}) => {

    return(
        <React.Fragment>
            <Button type={'link'}>
                <a target={'_blank'}  rel="noopener noreferrer" href={`recipe/details/${recipeId}`}>Detay</a>
            </Button>
        </React.Fragment>
    )
}
export default RecipeDetail